import React from 'react';

import {useTranslation} from 'react-i18next';

import {BackTo} from 'components/common/BackTo';
import {Page} from 'components/common/Page';
import {ContentContainer} from 'components/ui-kit/PageComponents/ContentContainer';
import {ROUTE} from 'core/routes';

export function ProductsByStatusesReport() {
    const {t, i18n} = useTranslation();

    return (
        <Page title={t('pages.reports.productsByStatuses')}>
            <BackTo to={ROUTE.REPORTS}>{t('pages.reports.back')}</BackTo>
            <ContentContainer>
                <div style={{minHeight: '500px', paddingTop: 10}}>
                    <iframe
                        title={t('pages.reports.productsByStatuses')}
                        width="100%"
                        height="600"
                        src={
                            i18n.language === 'en'
                                ? '/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports&reportUnit=%2Freports%2F002_cm_status_en&standAlone=true&j_username=user_ro&j_password=AbjSlbFbR6vjIX6&decorate=no'
                                : '/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports&reportUnit=%2Freports%2F002_cm_status&standAlone=true&j_username=user_ro&j_password=AbjSlbFbR6vjIX6&decorate=no'
                        }
                    />
                </div>
            </ContentContainer>
        </Page>
    );
}
